import React, { useState } from "react";
import TaskView from "../common/TaskView";
import { AcousticTask, AcousticTaskDefinition } from "../common/models";
import { Typography } from "@mui/material";
import { randomUUID } from "../../../utils";
import { translateReactNode } from "../../../../utils/translateReactNode";

const Definition: AcousticTaskDefinition = {
  name: "Respiration and cough (v2)",
  title: "Respiration and cough",
  description: "Breathing sounds can also provide information on your health. Let's record them.",
  cohort: 'generic',
  type: 'acoustic-task',
  estimatedCompletionTime: '5:20',
  subTaskDefinitions: [{
    name: "Respiration and cough (v2)-Breath",
    title: "",
    instructions:
      <Typography variant="h5" component='div'>
         After pressing on record, breathe comfortably through your mouth for 20 seconds, until the timer runs out.
      </Typography>
    ,
    profileName: 'breathe',
    stopwatchSeconds: 20,
  }, {
    name: "Respiration and cough (v2)-ThreeBreathsNose",
    title: "",
    instructions:
      <Typography variant="h5" component='div'>
        After pressing on record, exhale normally, then inhale quickly through your mouth, as if you are trying to catch your breath. Record 3 of these breaths in a single recording. Tap stop when finished.
      </Typography>,
    profileName: 'breathe'
  }, {
    name: "Respiration and cough (v2)-ThreeBreathsMouth",
    title: "",
    instructions:
      <Typography variant="h5" component='div'>
        After pressing on record, take 3 deep breaths in and out through your nose with your mouth closed. Tap stop when finished.
      </Typography>,
    profileName: 'breathe'
  }, {
    name: "Respiration and cough (v2)-ThreeBreaths",
    title: "",
    instructions:
      <Typography variant="h5" component='div'>
        After pressing on record, take 3 deep breaths in and out through your mouth. Tap stop when finished.
      </Typography>
    ,
    profileName: 'breathe'
  }, {
    name: "Respiration and cough (v2)-HardCough",
    title: "",
    instructions:
      <>
        <Typography variant="h5" component='div' sx={{ marginBottom: '2rem' }}>
          Please do not cover your mouth or place your hand between your mouth and the microphone during recording.
        </Typography>
        <Typography variant="h5" component='div'>
          Breathe normally, then when you are ready, tap the record button below and cough HARD as if something were stuck in your throat. Tap stop when finished.
        </Typography></>,
    profileName: 'cough'
  }]
};
export const RespirationAndCoughDefinition = Definition;

export const RespirationAndCough =  ({onCompletion}: {onCompletion: () => void}) => {
  const [task, _setTask] = useState<AcousticTask>(() => ({
    ...Definition,
    id: randomUUID(),
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'pending',
    subTasks: Definition.subTaskDefinitions.map((definition) => ({
      ...definition,
      id: randomUUID(),
      instructions: translateReactNode(definition.instructions, Definition.cohort),
      title: translateReactNode(definition.title, Definition.cohort) as string
    })),

  }));

  const handleOnCompletion = () => {
    console.log("Audio task completed", task.title);
    onCompletion();
  }

  return (
    <div>
      <TaskView
        task={task}
        onCompletion={handleOnCompletion}
        />
    </div>
  );
}
